import React, { useEffect, useContext } from "react";
import { useRouter } from "next/router";

import classes from "./ItemCollection.module.scss";
import ItemCard from "@/components/card/ItemCard";

//Content
import { WishlistContext } from "@/contexts/WishlistContext";

// Items in multiple rows (pair with Item.jsx)
function ItemCollection(props) {
  const router = useRouter();
  const { itemListing } = props;
  const { handleFavourite, getFavouriteStatus, isLoading } =
    useContext(WishlistContext);

  const handleAddItemToCart = async (item, quantity) => {
    handleViewItem(item);
  };

  //View Product in Detail
  const handleViewItem = (data) => {
    router.push({
      pathname: "/" + data.seoUrl,
      state: data,
    });
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  //   }, 300);
  // }, []);

  //Listing Product
  return (
    <div className={classes.container}>
      {itemListing.map((data, index) => {
        const imageDisplay = process.env.BUCKET_URL + data.cover;
        let itemQuantity = 0;
        let favStatus = getFavouriteStatus(data.itemId);
        return (
          <React.Fragment key={index}>
            <ItemCard
              handleViewItem={handleViewItem}
              handleFavourite={handleFavourite}
              handleAddItemToCart={handleAddItemToCart}
              data={data}
              price={
                data.deliveryPriceWithTax
                  ? data.deliveryPriceWithTax
                  : data.deliveryPrice
              }
              discountedPrice={data.deliveryCompareAtPrice}
              favStatus={favStatus}
              isLoading={isLoading}
              itemQuantity={itemQuantity}
              quantity={1}
              imageDisplay={imageDisplay}
              source="ItemCollection"
            />
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default ItemCollection;
